import { DefaultButton } from '@micro-frontend-react/employee-experience/lib/Buttons/DefaultButton';
import { css } from 'styled-components';
import { NotAllowedImage } from './NotAllowed.image';

export const Wrapper = styled.div<{ height: number }>`
  position: relative;

  ${({ height }) => css`
    height: ${height - 150}px;
  `};
`;

export const Root = styled.div<{ height: number }>`
  text-align: center;
  transform: translate(-50%, -50%);
  top: 50%;
  position: absolute;
  left: 50%;
`;

export const Image = styled.img.attrs({ src: NotAllowedImage })`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 43px;
  width: 195px;
  height: auto;
`;

export const Heading = styled.h2`
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  color: rgb(0, 0, 0);
  margin-bottom: 16px;
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: rgb(23, 23, 23);
  margin-bottom: 30px;
`;

export const GuestMode = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: rgb(23, 23, 23);
  margin-bottom: 20px;
`;

export const ButtonLink = styled(DefaultButton)`
  font-weight: 400;
  text-align: left;
  height: auto;
  min-width: 0;
  color: rgb(0, 90, 158);
  padding: 0;
  border: 0;
  margin-left: 0;
  background-color: transparent;

  & span {
    margin-left: 0;
  }

  &&&:hover {
    background-color: transparent;
    color: rgb(0, 80, 169);
    text-decoration: underline;
  }
`;
